import { render, staticRenderFns } from "./TipoAvaliacao.vue?vue&type=template&id=bf890e78&"
import script from "./TipoAvaliacao.vue?vue&type=script&lang=js&"
export * from "./TipoAvaliacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports